import { apiSlice } from '@api'

export interface DashboardFilterPayload {
  Name: string
  List?: string[]
  Label?: string
  Type?: string | typeof Date
  Amount?: number | string | null
  Options?: string
}

export interface AssetTrendPoint {
  Quarter: string
  Active: number
  DisposedAndPending: number
}

export interface CategorySnapshotPoint {
  CategoryName: string
  Active: number
  DisposedAndPending: number
}

export interface AcquisitionQuarterData {
  Quarter: string
  Active: number
  Disposed: number
  Totals: number
}

export interface BookValueQuarterData {
  Quarter: string
  Acquisition: number
  LTDDepreciation: number
  BookValue: number
}

export interface DashboardTotals {
  AssetCount: number
  TotalAcquisition: number
  TotalBookValue: number
}

export interface DashboardResponse {
  AssetTrend: AssetTrendPoint[]
  CategorySnapshot: CategorySnapshotPoint[]
  AcquisitionByQuarter: AcquisitionQuarterData[]
  BookValueByQuarter: BookValueQuarterData[]
  Totals: DashboardTotals
}

interface DashboardRequest {
  assetCompanyID: number
  filter: DashboardFilterPayload[]
}

export const dashboardEndpoints = apiSlice.injectEndpoints({
  endpoints: build => ({
    getDashboardAssets: build.query<DashboardResponse, DashboardRequest>({
      query: ({ assetCompanyID, filter }) =>
        `Dashboard/GetDashboardData?assetCompanyID=${assetCompanyID}&filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`,
      providesTags: ['dashboard'],
      keepUnusedDataFor: 7200,
    }),
  }),
  overrideExisting: false,
})

export const { useGetDashboardAssetsQuery } = dashboardEndpoints
